import Button from "../Button/Button";
import Divider from "../Divider/Divider";

export default function DeleteItemForm({ item, onDelete, onClose }) {
    return (
        <div>
            <h1 className="text-xl font-bold mb-2">
                Delete Item
            </h1>
            <Divider />
            <p className="mb-6">
                Are you sure you want to permanently delete <strong>{item.name}</strong>?
            </p>
            <div className="flex justify-end gap-4">
                <Button variant="ghost" onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant="danger"
                    onClick={() => {
                        onDelete(item.id);
                        onClose();
                    }}
                >
                    Delete Item
                </Button>
            </div>
        </div>
    );
}
